<template>
  <div class="gpt-editor-promptTemplate">
    <div class="content">
        <el-form v-if="template" label-width="6em" label-suffix="：">
            <el-form-item label="编码">
                {{template.code}}
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model="template.name"></el-input>
            </el-form-item>
            <!-- <el-form-item label="描述">
                <el-input type="textarea" :rows="2" v-model="template.remark"></el-input>
            </el-form-item> -->
        </el-form>
        <el-input v-if="template" type="textarea" class="prompt-content" v-model="template.content"></el-input>
        <div class="footer">
            <div class="rightplace">
                <el-button @click="reset">恢复</el-button>
                <el-button type='primary' @click="update">更新</el-button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import modelAPI from '@/api/model.api.js';
export default {
    name: 'gpt-editor-promptTemplate',
    data () {
        let template = {
            content: ''
        };
        let settings = {
            maxLength: 1024,
            contextLimit: 3,
            temperature: 0.6
        };
        return { template, settings };
    },
    props: {
        model: {
            type: Object,
            default: null
        },
        promptTemplate: {
            type: Object,
            default: null
        }
    },
    watch: {
        promptTemplate () {
            this.reset();
        }
    },
    async mounted () {
        this.reset();
    },
    methods: {
        async load () {
            if (!this.promptTemplate) return;
            let templateId = this.promptTemplate.id;
            let ret = await modelAPI.getPromptTemplate(templateId);
            this.template = ret.data;
        },
        /**
         * 重置
         */
        async reset () {
            this.template = cloneDeep(this.promptTemplate);
            await this.load();
        },

        /**
         * 更新
         */
        async update () {
            // localStorage里存储maxLength、contextLimit、temperature参数设置
            if (this.settings) {
                this.settings = cloneDeep(this.model.modelSettings);
                this.settings.value = this.model.value; // 模型名称
                this.$store.commit('appSettings/changeModelSettings', this.settings);
                this.$message.success('参数修改成功');
            }
            // 调用接口修改模型提示词
            if (this.template) {
                let ret = await modelAPI.updatePromptTemplate(this.template);
                if (ret.data) {
                    this.$message.success('提示词修改成功');
                } else {
                    this.$message.error('提示词修改失败: ' + ret.opDesc);
                }
            }

            this.model.modelSettings = this.settings;
            this.$emit('update:promptTemplate', this.template);
        },

        input () {
            this.$emit('input', this.template.content);
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-editor-promptTemplate {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 2em;
    background: var(--page-bg-img);
    background-size: cover;
    .content {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #FFF;
        border-radius: 0.5em;
        padding: 1em;
        overflow: auto;
        .prompt-content {
            height: calc(100% - 10em);
            &::v-deep {
                .el-textarea__inner {
                    position: relative;
                    height: 100%;
                }
            }
        }
    }
    .footer {
        margin-top: 0.5em;
    }
    .rightplace {
        float: right;
    }

    .el-form {
        .el-form-item {
            margin-bottom: 4px;
            .el-input-number{
                width: 110px;
                }
            .el-slider{
                padding-left: 20px;
                display:inline-block;
                vertical-align: bottom;
                width:calc(100% - 110px);
            }
        }
    }
}
</style>
